import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notificationController } from 'infrastructure/antd/controllers/notification-controller';
import { useTranslation } from 'react-i18next';
import dataService, { type IResponse } from 'services/dataService';
import { apiUnassignTask } from 'services/dataService/resources/oneplatform/api';

import { QUERY_KEYS } from '../constants';

interface IUnassignParams {
  taskGuid: string;
  returnNote: string;
}

export function useUnassignDashboardTask() {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: ({ taskGuid, returnNote }: IUnassignParams) =>
      dataService.createOne(apiUnassignTask(taskGuid), { returnNote }),
    onSuccess: (response: IResponse<unknown>) => {
      if (response.error) {
        notificationController.error({
          message: t('tasksDashboard.returnError'),
        });
        return;
      }

      notificationController.success({
        message: t('tasksDashboard.returnSuccess'),
      });
      queryClient.invalidateQueries([QUERY_KEYS.dashboardTasks]);
      queryClient.invalidateQueries([QUERY_KEYS.tasksBadgeCount]);
    },
  });
}
